module.exports = __webpack_public_path__ + "static/media/colicoli3.894d2623.webp";